import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ca-verification-input',
    styleUrls: ['./verification-input.component.scss'],
    templateUrl: './verification-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CaVerificationInputComponent),
        },
    ],
    standalone: false
})
export class CaVerificationInputComponent implements ControlValueAccessor, OnDestroy {
  @ViewChild('code') codeInput: ElementRef;
  @Output() value: EventEmitter<String> = new EventEmitter();
  @Input() light: boolean;

  onChange: (value: string) => void;
  onTouched: () => void;
  onValidatorChange: () => void;

  codeLength: number = 6;
  codeLengthArray: Array<string> = Array(this.codeLength).fill('0');
  codeControl = new UntypedFormControl('');
  isFocussed: boolean = false;
  isDisabled: boolean = false;

  private valueSub;

  constructor() {
    this.valueSub = this.codeControl.valueChanges.subscribe((input) => {
      if (this.onChange) {
        this.onChange(input);
      }
      this.value.next(input);
    });
  }
  ngOnDestroy(): void {
    this.valueSub.unsubscribe();
  }

  writeValue(obj: string): void {
    this.codeControl.patchValue(obj);
    for (let i = 0; i < this.codeLength; i++) {
      this.codeLengthArray[i] = obj?.charAt(i) ?? '0';
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  focusInput() {
    this.codeInput.nativeElement.focus();
  }

  numericOnly(event): boolean {
    return /^([0-9])$/.test(event.key);
  }
}
